import _slicedToArray from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/toast.utils.ts
var findById = function findById(arr, id) {
  return arr.find(function (toast) {
    return toast.id === id;
  });
};
function findToast(toasts, id) {
  var position = getToastPosition(toasts, id);
  var index = position ? toasts[position].findIndex(function (toast) {
    return toast.id === id;
  }) : -1;
  return {
    position: position,
    index: index
  };
}
function getToastPosition(toasts, id) {
  for (var _i = 0, _Object$entries = Object.entries(toasts); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      position = _Object$entries$_i[0],
      values = _Object$entries$_i[1];
    if (findById(values, id)) {
      return position;
    }
  }
}
var isVisible = function isVisible(toasts, id) {
  return !!getToastPosition(toasts, id);
};
function getToastStyle(position) {
  var isRighty = position.includes("right");
  var isLefty = position.includes("left");
  var alignItems = "center";
  if (isRighty) alignItems = "flex-end";
  if (isLefty) alignItems = "flex-start";
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: alignItems
  };
}
function getToastListStyle(position) {
  var isTopOrBottom = position === "top" || position === "bottom";
  var margin = isTopOrBottom ? "0 auto" : void 0;
  var top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
  var bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
  var right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
  var left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
  return {
    position: "fixed",
    zIndex: 5500,
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: margin,
    top: top,
    bottom: bottom,
    right: right,
    left: left
  };
}
export { findById, findToast, getToastPosition, isVisible, getToastStyle, getToastListStyle };